import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Calendar, MapPin } from 'lucide-react';

const BACKEND_URL = 'https://api.artwithsaloni.com';
// const BACKEND_URL = /^https?:\/\//i.test(RAW_BACKEND_URL)
//   ? RAW_BACKEND_URL
//   : `https://${RAW_BACKEND_URL}`;
const API = `${BACKEND_URL}/api`;

const Events = () => {
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const [upcomingRes, pastRes] = await Promise.all([
        axios.get(`${API}/events/upcoming/`),
        axios.get(`${API}/events/past`) 
      ]);
      setUpcomingEvents(upcomingRes.data);
      setPastEvents(pastRes.data);
    } catch (error) {
      console.error('Error fetching events:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Date TBA';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const EventCard = ({ event }) => (
    <div style={{
      backgroundColor: 'var(--color-white)',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
      transition: 'transform var(--transition-base), box-shadow var(--transition-base)'
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-4px)';
      e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.12)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
    }}
    >
      {event.image_url && (
        <img
          src={`${BACKEND_URL}${event.image_url}`}
          alt={event.title}
          style={{
            width: '100%',
            height: '250px',
            objectFit: 'cover'
          }}
        />
      )}
      <div style={{ padding: 'var(--spacing-lg)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: 'var(--spacing-sm)' }}>
          <Calendar size={16} color="var(--color-primary)" />
          <span className="caption-text" style={{ color: 'var(--color-gray-600)' }}>
            {formatDate(event.event_date)}
          </span>
        </div>
        <h3 className="artist-name" style={{ marginBottom: 'var(--spacing-sm)', fontSize: '1.5rem' }}>
          {event.title}
        </h3>
        {event.description && (
          <p className="body-text" style={{ color: 'var(--color-gray-700)' }}>
            {event.description}
          </p>
        )}
      </div>
    </div>
  );

  if (loading) {
    return (
      <div style={{ padding: 'var(--spacing-2xl)', textAlign: 'center' }}>
        <p className="body-text">Loading events...</p>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: 'var(--color-white)', minHeight: '100vh' }}>
      {/* Header */}
      <section className="section-spacing" style={{ backgroundColor: 'var(--color-gray-100)' }}>
        <div className="container-artworld" style={{ textAlign: 'center' }}>
          <h1 className="section-title" style={{ marginBottom: 'var(--spacing-md)' }}>
            Events & Workshops
          </h1>
          <p className="body-text" style={{ maxWidth: '600px', margin: '0 auto' }}>
            Join me for upcoming workshops, events, and art experiences. Connect, create, and celebrate together!
          </p>
        </div>
      </section>

      {/* Upcoming Events */}
      <section className="section-spacing-large">
        <div className="container-artworld">
          <h2 className="section-title" style={{ marginBottom: 'var(--spacing-xl)', textAlign: 'center' }}>
            Upcoming Events
          </h2>
          {upcomingEvents.length > 0 ? (
            <div className="artist-grid">
              {upcomingEvents.map((event) => (
                <EventCard key={event.id} event={event} />
              ))}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: 'var(--spacing-2xl)' }}>
              <p className="body-text" style={{ color: 'var(--color-gray-500)' }}>
                No upcoming events at the moment. Check back soon!
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Past Events */}
      <section className="section-spacing-large" style={{ backgroundColor: 'var(--color-gray-100)' }}>
        <div className="container-artworld">
          <h2 className="section-title" style={{ marginBottom: 'var(--spacing-xl)', textAlign: 'center' }}>
            Past Events
          </h2>
          {pastEvents.length > 0 ? (
            <div className="artist-grid">
              {pastEvents.map((event) => (
                <EventCard key={event.id} event={event} />
              ))}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: 'var(--spacing-2xl)' }}>
              <p className="body-text" style={{ color: 'var(--color-gray-500)' }}>
                No past events to display yet.
              </p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Events;
